import type {
	TableOfContentsUmbBlockElementModel,
	TableOfContentsUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import type { TocDisplay } from "#/_packages/umbrella/features/table-of-contents/components";
import { TableOfContents } from "#/_packages/umbrella/features/table-of-contents/components";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import {
	tryGetAnimationScrollType,
	tryGetBoxVariant,
	tryGetButtonVariant,
	tryGetHeadingLevel,
	tryGetIntent,
	tryGetSize,
} from "#/_packages/umbrella/utils";

interface ITableOfContentsBlockProps extends BlockItemProps {
	content: TableOfContentsUmbBlockElementModel;
	settings: TableOfContentsUmbBlockSettingsElementModel;
}

function tryGetDisplay(value?: string | null): TocDisplay {
	return value === "grid" ? "grid" : "flex";
}

export function TableOfContentsUmbBlock({
	content,
	settings,
	className,
}: ITableOfContentsBlockProps) {
	const alignment = settings.properties?.alignmentSelfVertical;
	return (
		<TableOfContents
			id={settings.properties?.generatedId}
			textLabel={content.properties?.textLabel}
			hideHeading={content.properties?.hideHeading ?? false}
			boxVariant={tryGetBoxVariant(settings.properties?.boxVariant)}
			display={tryGetDisplay(content.properties?.display)}
			alignmentSelfVertical={
				alignment === "center" || alignment === "end" ? alignment : "start"
			}
			collapse={content.properties?.collapse ?? false}
			sticky={settings.properties?.position === "sticky"}
			headingLevel={tryGetHeadingLevel(content.properties?.headingLevel, 4)}
			headingAppearance={content.properties?.headingAppearance}
			animationHoverType={settings.properties?.animationHoverType ?? []}
			animationScrollType={tryGetAnimationScrollType(
				settings.properties?.animationScrollType,
			)}
			size={tryGetSize(content.properties?.size)}
			intentColor={tryGetIntent(content.properties?.intentColor)}
			typeVariant={tryGetButtonVariant(content.properties?.typeVariant)}
			iconSvgId={content.properties?.icon}
			iconPosition={content.properties?.iconPosition}
			iconRotation={content.properties?.iconRotation}
			className={className}
		/>
	);
}
